import { Link, Text } from 'platform-components';
import { UI_KIT_TEXT_TYPOGRAPHY } from 'platform-components/constants';
import React from 'react';
import { accessibleClick } from '@edu-frontend/modules/src/shared/lib/a11y';

import './stack-card.scss';

export interface Props {
    problemPreview: string;
    linkTextId?: string;
    linkUrl: string;
    isLinkPseudo?: boolean;
    name: string;
    onClick: () => void;
    variantsCount?: number;
}

const StackCard = (props: Props) => {
    const {
        problemPreview,
        isLinkPseudo,
        linkTextId = 'stackCard.linkText',
        linkUrl,
        name,
        onClick,
        variantsCount = 1,
    } = props;

    return (
        <article className="stack-card" {...accessibleClick(onClick)}>
            <div className="stack-card__wrapper">
                <div className="stack-card__problem-preview" style={{ backgroundImage: `url(${problemPreview})` }} />
                <div className="stack-card__body">
                    <Text className="stack-card__name" typography={UI_KIT_TEXT_TYPOGRAPHY.paragraphLRegular}>
                        {name}
                    </Text>
                    <footer className="stack-card__footer">
                        <Link mix="stack-card__link" pseudo={isLinkPseudo} theme={Link.THEME.PRIMARY} to={linkUrl}>
                            <Text id={linkTextId} typography={UI_KIT_TEXT_TYPOGRAPHY.paragraphLMedium} />
                        </Link>
                        <Text
                            className="stack-card__variants-count"
                            id="stackCard.addedVariantsAmount"
                            typography={UI_KIT_TEXT_TYPOGRAPHY.captionXSMediumWider}
                            values={{ defaultVariant: 1, count: variantsCount }}
                        />
                    </footer>
                </div>
            </div>
        </article>
    );
};

export default StackCard;
